<template>
  <g
    id="Right_Rear_View_Mirror"
    v-on:click="changeSeverity('rightRearViewMirror')"
    :class="severityClass"
  >
    <path
      class="cls-532"
      d="M402.45,380.06c.29-.75,.27-1.58-.06-2.32l-1.51-3.44-1.01,.32,1.52,3.47c.23,.53,.25,1.13,.04,1.67l-2.89,7.56c-.22,.57-.26,1.19-.12,1.78l1.52,6.47,1.05-.18-1.52-6.49c-.1-.42-.07-.87,.09-1.28l2.89-7.56Z"
    />
    <path
      class="cls-955"
      d="M400.5,375.3l-2.25,1.79c-.12,.1-.26,.17-.41,.21-.11,.03-.21,.05-.33,.05h-.43c-.32,0-.58-.26-.58-.58v-13.38c0-.32,.26-.58,.58-.58h.22c.19,0,.37,.04,.54,.13,.18,.09,.33,.21,.44,.38l3.3,4.8c1.58,2.31,1.11,5.44-1.08,7.18Z"
    />
    <path
      class="cls-355"
      d="M397.84,362.94v14.36c-.11,.03-.21,.05-.33,.05h-.43c-.32,0-.58-.26-.58-.58v-13.38c0-.32,.26-.58,.58-.58h.22c.19,0,.37,.04,.54,.13Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
